export default __webpack_public_path__ + "static/media/GoodStory.227a708b.png";